import type { ReactElement } from 'react'
import { BlockStack, Modal, Text } from '@shopify/polaris'
import type { InvoiceWhatsNewEntryVM } from './contentful'
import { formatWhatsNewModalDate } from './date'
import { WhatsNewRichText } from './WhatsNewRichText'

type InvoiceWhatsNewDetailModalProps = {
  open: boolean
  onClose: () => void
  entry: InvoiceWhatsNewEntryVM | null
}

export const InvoiceWhatsNewDetailModal = ({
  open,
  onClose,
  entry,
}: InvoiceWhatsNewDetailModalProps): ReactElement => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={entry?.detailHeading ?? 'Update'}
      secondaryActions={[{ content: 'Close', onAction: onClose }]}
    >
      <Modal.Section>
        {entry ? (
          <BlockStack gap="400">
            <Text as="p" variant="bodyMd" tone="subdued">
              {formatWhatsNewModalDate(entry.date ?? entry.createdAt)}
            </Text>
            <WhatsNewRichText document={entry.description} />
          </BlockStack>
        ) : null}
      </Modal.Section>
    </Modal>
  )
}
